import React from 'react';
import { Calendar, ArrowRight, Shield, Zap, Search } from 'lucide-react';
import { Link } from 'react-router-dom';

// THE REGISTRY: This replaces your Supabase table.
// Add, remove, or edit posts here.
const MANIFEST_POSTS = [
  {
    id: 1,
    slug: 'verified-reviews',
    title: "How to Turn Client Feedback into Verified Online Reviews",
    date: "2026-04-04",
    excerpt: "Transform your customer feedback into authentic, trusted reviews that boost credibility and conversions. Learn the workflow for verified reviews, screenshot conversion, and embedding trust signals on your website.",
    image: "https://wnjcqclqpgqdyyomobeh.supabase.co/storage/v1/object/public/Blogs/Group%208816.png",
    category: "Forensics",
  },
  {
    id: 2,
    slug: 'trustpilot-alternatives',
    title: "Top Alternatives to Trustpilot | Sitemanifest",
    date: "2026-04-05",
    excerpt: "Traditional review platforms can be limiting and sometimes risky. Discover how verified reviews on Sitemanifest provide trust, control, and flexibility for global businesses.",
    image: "https://wnjcqclqpgqdyyomobeh.supabase.co/storage/v1/object/public/Blogs/Group%208818.png",
    category: "Architecture",
  },
  {
    id: 2,
    slug: 'state-of-reviews',
    title: "The State of Online Reviews (2026)",
    date: "2026-04-05",
    excerpt: "Online reviews influence billions in purchasing decisions. But in 2026, one question matters more than ever: can they actually be trusted?",
    image: "https://wnjcqclqpgqdyyomobeh.supabase.co/storage/v1/object/public/Blogs/Group%208819%20(1).png",
    category: "Research",
  },
  {
    id: 4,
    slug: 'why-verified-reviews-matter',
    title: "Why Verified Reviews Matter More Than Ever in 2026",
    date: "2026-04-10",
    excerpt: "We've entered a new era of commerce — one where your potential customer has already made up their mind before you even get to pitch them.",
    category: "Customer Experience",
  },

];

export default function BlogHome() {
    return (
        <div className="bg-[#D9D9D9] min-h-screen text-black font-poppins pb-20 pt-28 px-6 selection:bg-black selection:text-[#D9D9D9]">
            <div className="max-w-6xl mx-auto">
                <header className="mb-20 text-center relative">
                    <div className="inline-block bg-black text-[#D9D9D9] px-3 py-1 text-[10px] font-black uppercase tracking-[0.3em] mb-6">
                        Internal Manifest v1.1 // STATIC_ARCHIVE
                    </div>
                    <h1 className="text-7xl md:text-8xl font-black italic tracking-tighter uppercase mb-4 leading-[0.85] drop-shadow-sm">
                        The Manifest
                    </h1>
                    <p className="text-zinc-600 text-lg font-medium max-w-xl mx-auto border-l-2 border-black pl-4 text-left md:text-center md:border-l-0 md:pl-0">
                        Forensic analysis on digital trust, reputation extortion, and the engineering of truth.
                    </p>
                    <div className="h-[2px] w-full bg-black/10 mt-12 relative">
                      <div className="absolute top-0 left-1/2 -translate-x-1/2 h-full w-24 bg-black" />
                    </div>
                </header>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                    {MANIFEST_POSTS.map(post => (
                        <Link 
                            to={`/blogs/${post.slug}`} 
                            key={post.id} 
                            className="group flex flex-col bg-[#EEEEEE] border-[3px] border-black rounded-none overflow-hidden hover:translate-x-[-4px] hover:translate-y-[-4px] hover:shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] transition-all duration-200"
                        >
                      
                            
                            <div className="p-8 flex flex-col flex-1">
                                <div className="flex items-center gap-2 text-[10px] font-bold text-zinc-500 uppercase tracking-[0.2em] mb-6">
                                    <Calendar size={12} className="text-black" />
                                    {new Intl.DateTimeFormat('en-US', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(post.date))}
                                </div>
                                
                                <h2 className="text-3xl font-black leading-[0.9] mb-4 uppercase italic tracking-tighter group-hover:text-zinc-700 transition-colors">
                                    {post.title}
                                </h2>
                                
                                <p className="text-zinc-600 text-sm leading-tight mb-8 font-semibold tracking-tight">
                                    {post.excerpt}
                                </p>
                                
                                <div className="mt-auto pt-6 border-t-2 border-black/5 flex items-center justify-between font-black text-[10px] uppercase tracking-[0.2em]">
                                    <span>Initiate Read</span>
                                    <ArrowRight size={18} className="group-hover:translate-x-2 transition-transform" />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}